// @flow

import {Http} from './http';
import {failoverUrl as _failoverUrl, storageUrl, vodUrl} from './config';

/**
 * Normaliza las listas de CDN de la API v2 (`[{url, tokenized}]`) al array de hosts
 * planos que esperan playkit-js-hls y el overlay de error.
 * @param {any} list lista de CDNs
 * @returns {string[]} hosts
 */
function _hosts(list: any): string[] {
  if (!Array.isArray(list)) return [];
  return list.map(item => (typeof item === 'string' ? item : item && item.url)).filter(item => item && item.length);
}

/**
 * defaultJSON
 * El failover se pide siempre a la API v2, tanto para jsonProvider (v1) como para jsonProvider2.
 * @param {string} user user
 * @param {any} playerConfig playerConfig
 * @param {string} stream stream
 * @returns {void} defaultjSON data
 */
export default async function defaultJSON(user: string, playerConfig: any, stream?: string) {
  const local_failoverUrl = playerConfig.failoverUrl !== undefined && playerConfig.failoverUrl ? playerConfig.failoverUrl : _failoverUrl;
  const vodUrls = playerConfig.vodUrl !== undefined && playerConfig.vodUrl ? playerConfig.vodUrl : vodUrl;
  const stirageUrls = playerConfig.storageUrl !== undefined && playerConfig.storageUrl ? playerConfig.storageUrl : storageUrl;
  let data = {
    urls: [],
    vod: vodUrls,
    storage: [stirageUrls]
  };

  let streamUrls = [];
  if (stream !== undefined && stream) {
    try {
      const dataUserJson = await Http.execute(`${local_failoverUrl}/json/live/${user}.json`, null, 'GET');
      streamUrls = _hosts(dataUserJson[stream]);
    } catch (e) {
      // se resuelve con el failover por defecto
    }
  }
  if (streamUrls.length) {
    data.urls = streamUrls;
    return data;
  }

  const defaultDataJSON = await Http.execute(`${local_failoverUrl}/json/live/default.json`, null, 'GET');
  data.urls = _hosts(defaultDataJSON.urls);
  if (playerConfig.vodUrl === undefined || !playerConfig.vodUrl) {
    const defaultVodUrls = _hosts(defaultDataJSON.vod);
    if (defaultVodUrls.length) data.vod = defaultVodUrls;
  }
  return data;
}
